<template>
    <div class="flex border-b border-gray-400 pb-4">
        <input-radio-multi
            class="mt-4 flex-1"
            name="property_type"
            :value="property.property_type"
            :options="types"
            :nullable="true"
            :wrap="true"
            :read_only="read_only"
        />
    </div>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        types: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
